import { Box, Button, Typography, styled } from "@mui/material";

export const Text = styled(Typography)({
  fontSize: "13px",
  fontFamily: "Roboto",
  fontWeight: 400,
  color: "#afafaf",
});
export const DgTitle = styled(Typography)({
  color: "#4CAF50",
  fontSize: "15px",
  fontWeight: 500,
  textAlign: "center",
});
export const DTtitle = styled(Typography)({
  fontSize: "14px",
  fontWeight: 500,
  fontFamily: "Roboto",
  color: "#AFAFAF",
});

export const CashBox = styled(Box)(({ theme }) => ({
  background: "#FFFFFF",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "8px",
  borderRadius: "6px",
  minWidth: "250px",
}));
